import { get } from '@/ports/api'
import ENV_VARS from '@/config'

const { BACKEND_SERVER } = ENV_VARS

export const fetchFile = async (path: string, contentType = 'application/pdf') => {
  try {
    const data = await get(`${BACKEND_SERVER}${path}`, {
      noLoading: true,
      failSilently: true,
      responseType: 'blob',
      defaultHeaders: { 'Content-Type': contentType }
    })()
    if (!data || !data.response.ok) throw new Error('Non 200 response')
    return data.body
  } catch (e) {
    throw new Error(`Download failed for ${path}`)
  }
}

export const downloadFile = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
}
